<template>
  <div class="loaderContainer">
    <div class="mx-auto">
      <PaymentDetailSDD v-if="params.methodTypeId === 1" 
        @confirm="startPayment" 
        @abort="abort"  
        @stopLoader='stopLoader()' 
        @startLoader='startLoader()'
        :params="params"/>
      <PaymentDetailSDDB2B v-else-if="params.methodTypeId === 6" 
        @confirm="startPayment" 
        @abort="abort" 
        @stopLoader='stopLoader()' 
        @startLoader='startLoader()'
        :params="params"/>
      <PaymentDetailPISP v-else-if="params.methodTypeId === 11" 
        @confirm="startPayment" 
        @abort="abort"
        :params="params"/>
    </div>
  </div>
</template>

<script>
// import { VCard } from 'vuetify/lib'
import PaymentDetailSDD from '@/views/payment/views/desktop/start/PaymentDetailSDD'
import PaymentDetailSDDB2B from '@/views/payment/views/desktop/start/PaymentDetailSDDB2B'
import PaymentDetailPISP from '@/views/payment/views/desktop/start/PaymentDetailPISP'
import RequestHandler from '../../../mixins'
import testData from '../testData'

export default {
  name: 'PaymentStart',
  components: { PaymentDetailSDD, PaymentDetailSDDB2B, PaymentDetailPISP } ,
  mixins: [RequestHandler],
  props: {
    params: {
      type: Object,
      default: () => ({})
    },
    origin: {
      type: String,
      default: ''
    }
  },
  created: function () {
    this.stopLoader()
    if (!this.needsInput(this.params.methodTypeId)) this.startPayment({})
  },
  methods: {
    startPayment (data) {
      this.startLoader()
      // copy form data in case user uses back button before end of payment
      this.params.lastUserEntry = {...data}
      data.paymentMethodTypeId = this.params.methodTypeId
      data.paymentMethodId = this.params.methodId
      if (this.params.aliasId) data.aliasId = this.params.aliasId
      if (this.params.registerAlias) data.registerAlias = (this.params.registerAlias === '1' || this.params.registerAlias === true) ? '1' : '0'
      if (this.params.aliasLabel) data.aliasLabel = this.params.aliasLabel
      if (this.params.details) data = {...this.params.details, ...data}
      if (!this.params.doNotAddDetails && this.params.mkpData.details) data = {...this.params.mkpData.details, ...data}

      this.callStartPayment(data).then(rep => {
        this.stopLoader()
        if (process.env.NODE_ENV !== 'production') {
          this.params.startPaymentData = data
          this.$emit('paymentStarted',  testData.startPaymentRedirect) 
        }
        else {
          if (!rep) throw new Error(this.$t('error_startpayment'))

          const content = rep.content
          if (content.statusCode === '0') {
            this.params.startPaymentData = data
            this.$emit('paymentStarted', content)
          }
        }
      })
      .catch(err => {
        this.stopLoader()
        this.setFatalError({ description: this.$t(err.message)})
      })
    },
    stopLoader () {
      this.$emit('stopLoader')
    },
    startLoader () {
      this.$emit('startLoader')
    },
    abort () {
      this.$emit('abort')
    },
    needsInput (methodTypeId) {
      let result = false
      switch (methodTypeId) {
        case 1:
        case 6:
        case 11: 
          result = true
          break
        default:
          break;
      }
      return result
    }
  }
}
</script>
